import { useEffect } from "react";

export default function SEO({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
}) {
  useEffect(() => {
    // This runs after component mounts
    if (typeof window !== "undefined") {
      // Set title
      document.title = title;

      // Update canonical - remove old ones first
      const oldCanonicals = document.querySelectorAll('link[rel="canonical"]');
      oldCanonicals.forEach((link) => link.remove());

      const canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      canonicalLink.href = canonical;
      document.head.appendChild(canonicalLink);

      // Update description
      let desc = document.querySelector('meta[name="description"]');
      if (desc) {
        desc.content = description;
      } else {
        desc = document.createElement("meta");
        desc.name = "description";
        desc.content = description;
        document.head.appendChild(desc);
      }

      // Update OG tags
      let ogTitleMeta = document.querySelector('meta[property="og:title"]');
      if (ogTitleMeta) {
        ogTitleMeta.content = ogTitle || title;
      } else {
        ogTitleMeta = document.createElement("meta");
        ogTitleMeta.setAttribute("property", "og:title");
        ogTitleMeta.content = ogTitle || title;
        document.head.appendChild(ogTitleMeta);
      }

      let ogDescMeta = document.querySelector(
        'meta[property="og:description"]',
      );
      if (ogDescMeta) {
        ogDescMeta.content = ogDescription || description;
      } else {
        ogDescMeta = document.createElement("meta");
        ogDescMeta.setAttribute("property", "og:description");
        ogDescMeta.content = ogDescription || description;
        document.head.appendChild(ogDescMeta);
      }
    }
  }, [title, description, canonical, ogTitle, ogDescription]);

  // Render a script that executes immediately for react-snap
  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function() {
              document.title = ${JSON.stringify(title)};
              
              var canonical = document.querySelector('link[rel="canonical"]');
              if (canonical) {
                canonical.href = ${JSON.stringify(canonical)};
              } else {
                var link = document.createElement('link');
                link.rel = 'canonical';
                link.href = ${JSON.stringify(canonical)};
                document.head.appendChild(link);
              }
              
              var desc = document.querySelector('meta[name="description"]');
              if (desc) {
                desc.content = ${JSON.stringify(description)};
              }
            })();
          `,
        }}
      />
    </>
  );
}
